import React from 'react';
import styled from 'styled-components';
import { Text } from '../../components/typography';

export const RedText = styled.span`
  color: ${({ theme }) => theme.colors.red};
`;

export const GreenText = styled.span`
  color: ${({ theme }) => theme.colors.green};
`;

export const VerticalLine = styled.div`
  flex: 1;
  border-left: 1px solid #dadada;
`;

export function Or() {
  return (
    <OrContainer>
      <div />
      <Text size="lg" weight="bold">
        or
      </Text>
      <div />
    </OrContainer>
  );
}

const OrContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;

  > div {
    flex: 1;
    border-left: 1px solid #dadada;
  }
`;
